/* eslint-disable indent */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import * as VeeValidate from 'vee-validate'

initInterceptAxios()

const app = createApp(App)
app.use(store).use(router).use(VeeValidate)
app.mount('#app')

function initInterceptAxios() {
    // intercepting request
    axios.interceptors.request.use(function(config) {
            if (store.state.auth.loggedInState && store.state.auth.accessToken) {
                config.headers.Authorization = 'Bearer ' + store.state.auth.accessToken
            }
            return config
        }, function(error) {
            // Do something with request error
            return Promise.reject(error)
        })
        // intercepting responses
    axios.interceptors.response.use(function(response) {
        // Do something with response data
        return response
    }, function(error) {
        // Do something with response error
        if (error && error.response && error.response.status === 401) {
            store.dispatch('unauthorizedAction')
        }
        return Promise.reject(error)
    })
}